import {
  LockOutlined,
  MailOutlined,
  PhoneOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Form, Input, Radio, Select } from 'antd';
import { FormSectionsSeparator } from 'features/users/components/modals/form-sections-separator';
import {
  UserFormField,
} from 'features/users/components/users-filter-form';
import { useRoleAgent } from 'features/users/use-cases/get-role';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { noExtraSpaces } from 'routes/utils';
import { phoneNumberPattern } from 'utils/validations';

const { TextArea } = Input;
export const UserInfoFormItems = ({ id }: any) => {
  const { t } = useTranslation();
  const { data: RoleAgent } = useRoleAgent('' as any)
  const loctaion = useLocation()
  const basePath = loctaion.pathname.split("/").slice(0, 3).join("/");

  
  return (
    <FormSectionsSeparator title={""}>
      <Form.Item<UserFormField>
        label={t('adminUsers.formFields.firstName.label')}
        name={UserFormField.FirstName}
        rules={[
          { required: true },
          { validator: noExtraSpaces },
          {
            pattern: /^[A-Za-z\s]+$/,
            message: "Name must contain only letters.",
          }
        ]}
      >
        <Input
          placeholder={t('adminUsers.formFields.firstName.placeholder')}
          prefix={<UserOutlined className='input-prefix-icon' />}
        />
      </Form.Item>
      <Form.Item<UserFormField>
        label={t('adminUsers.formFields.lastName.label')}
        name={UserFormField.LastName}
        rules={[
          { required: true },
          { validator: noExtraSpaces },
          {
            pattern: /^[A-Za-z\s]+$/,
            message: "Name must contain only letters.",
          }
        ]}
      >
        <Input
          placeholder={t('adminUsers.formFields.lastName.placeholder')}
          prefix={<UserOutlined className='input-prefix-icon' />}
        />
      </Form.Item>

      <Form.Item<UserFormField>
        label={t('adminUsers.formFields.email.label')}
        name={UserFormField.Email}
        rules={[
          {
            required: false,
            whitespace: true,
          },
          {
            type: 'email',
            message: t('validateMessages.custom.email'),
          },
        ]}
      >
        <Input
          placeholder={t('adminUsers.formFields.email.placeholder')}
          prefix={<MailOutlined className='input-prefix-icon' />}
          disabled={id}
        />
      </Form.Item>
      {basePath !== "/users/admin" &&
        <Form.Item name="role" label="Role"
          rules={[
            {
              required: true,
              message: "Please select a role",
            },
          ]}
        >
          <Select
            style={{ width: "100%" }}
            placeholder="Select Role"
            options={RoleAgent?.items?.map((item: any) => ({
              label: item.role_name,
              value: item.role_name,
            }))}
          />
        </Form.Item>}
      <Form.Item<UserFormField>
        label={t('adminUsers.formFields.phoneNumber.label')}
        name={UserFormField.PhoneNumber}
        rules={[
          {
            required: true,
          },
          {
            pattern: phoneNumberPattern,
            message: t('validateMessages.custom.phoneNumber'),
          },
        ]}
      >
        <Input
          type='tel'
          placeholder={t('adminUsers.formFields.phoneNumber.placeholder')}
          prefix={<PhoneOutlined className='input-prefix-icon' />}
          autoComplete="off"
          maxLength={15}
          onKeyPress={(e) => {
            const isNumberOrPlus = /^[0-9+]*$/.test(e.key);
            const isBackspace = e.key === 'Backspace';
            const inputValue = (e.target as HTMLInputElement).value || '';
            const totalLength = inputValue.length + (isBackspace ? -1 : 1);
            if (!isNumberOrPlus || totalLength > 15) {
              e.preventDefault();
            }
          }}
        />
      </Form.Item>

      <Form.Item<UserFormField>
        label="Address"
        name={UserFormField.Address}
        rules={[
          {
            required: false,
          },
        ]}

      >
        <TextArea rows={4} />
      </Form.Item>

      <Form.Item<UserFormField>
        label="Is Active"
        name={UserFormField.IsActive}
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Radio.Group >
          <Radio value={true} > Yes</Radio>
          <Radio value={false}> No </Radio>
        </Radio.Group>
      </Form.Item>
      {id && 
      <Form.Item<UserFormField>
        label={'Change Password'}
        name={UserFormField.Password}
        rules={[
          {
            required: false,
            whitespace: true,
            min: 4,
          },
          {
            pattern: /(?=.*\d)/,
            message: t('validateMessages.custom.passwordDigit'),
          },
        ]}
      >
        <Input.Password
          placeholder={t('adminUsers.formFields.password.placeholder')}
          prefix={<LockOutlined className='input-prefix-icon' />}
        />
      </Form.Item>}

    </FormSectionsSeparator>
  );
};
